import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Button } from 'reactstrap'
import { addressLabel } from '../../util/utils'

const AddressCard = ({ address }) => (
  <Row className="cart-flex mf-border mf-pt-2 mf-pb-2 alert-success" style={{ borderRadius: '3px' }}>
    <Col sm={10}>{addressLabel(address)}</Col>
  </Row>
)

const ShippingAddressSection = () => {
  const history = useHistory()
  const {selectedCustomerAddress,
    multiAddressSelection,
    portal,
    currentUser
  } = useSelector(state => ({
    selectedCustomerAddress: state.checkout.selectedCustomerAddress,
    multiAddressSelection: state.checkout.multiAddressSelection,
    portal: state.portal,
    currentUser: state.currentUser
  }))

  // Check if multi-address mode is active
  const hasAddressSelection = useMemo(() => {
    if (!portal.multiple_address_shipping) return false
    if (!currentUser?.id) return false
    if (!multiAddressSelection?.length) return false

    return true
  }, [portal.multiple_address_shipping, currentUser?.id, multiAddressSelection])

  // Check if multiple unique addresses are selected
  const hasMultipleAddresses = useMemo(() => {
    if (!hasAddressSelection) return false
    const uniqueAddressIds = multiAddressSelection
      .map(sel => sel.address?.id)
      .filter((id, i, arr) => arr.indexOf(id) === i)
    return uniqueAddressIds.length > 1
  }, [hasAddressSelection, multiAddressSelection])

  const hasShippingAddress = !isEmpty(selectedCustomerAddress)

  const handleEditAddresses = () => history.push('/cart')


  return hasShippingAddress && (
    <div className="box-shadow white-background mf-m-0 mf-mb-3">
      <div className="ckout-header">
        <h5 className="mf-m-0">Shipping Address</h5>
      </div>
      <Container className="mf-pb-3">
        {hasMultipleAddresses && (
          <Row>
            <Col>
              <p style={{ paddingTop: '5px' }}>
                <em>Multiple Addresses selected - See Below</em>
              </p>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <AddressCard address={selectedCustomerAddress} />
          </Col>
        </Row>
        <Row className="mf-mt-3">
          <Col className="d-flex justify-content-end align-items-center">
            <Button outline color="secondary" onClick={handleEditAddresses}>
              Add / Edit Addresses
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ShippingAddressSection

